import CompanyInfoForm from './company_info_form';

export default CompanyInfoForm;
